import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AssignedUserCustomerDto } from '@shared/service-proxies/service-proxies';
import { UserInfoStore } from '@shared/services/user-info.store';
import { Observable, of } from 'rxjs';
import { AppSessionService } from '@shared/session/app-session.service';

@Injectable({
    providedIn: 'root',
})
export class UserInfoResolver implements Resolve<AssignedUserCustomerDto[]> {
    constructor(private userInfoStore: UserInfoStore, private appSession: AppSessionService) {}

    resolve(): Observable<AssignedUserCustomerDto[]> {
        if (!this.appSession.userId) {
            return of([]);
        }
        return this.userInfoStore.getUserInfosCall();
    }
}
